export async function createDemoFile(): Promise<File> {
  const canvas = document.createElement('canvas');
  canvas.width = 1200;
  canvas.height = 800;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas is unavailable in this browser.');

  const sky = ctx.createLinearGradient(0, 0, 1200, 800);
  sky.addColorStop(0, '#2f5f72');
  sky.addColorStop(0.42, '#d9c39b');
  sky.addColorStop(1, '#221f2a');
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, 1200, 800);

  ctx.fillStyle = 'rgba(248, 246, 240, 0.72)';
  ctx.beginPath();
  ctx.arc(900, 220, 92, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = 'rgba(22, 28, 36, 0.42)';
  ctx.beginPath();
  ctx.moveTo(0, 630);
  ctx.lineTo(260, 455);
  ctx.lineTo(450, 630);
  ctx.lineTo(660, 430);
  ctx.lineTo(980, 630);
  ctx.lineTo(1200, 500);
  ctx.lineTo(1200, 800);
  ctx.lineTo(0, 800);
  ctx.closePath();
  ctx.fill();

  ctx.fillStyle = 'rgba(246, 243, 236, 0.38)';
  for (let i = 0; i < 20; i += 1) {
    ctx.fillRect(80 + i * 52, 670 + Math.sin(i) * 12, 34, 2);
  }

  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92));
  if (!blob) throw new Error('Could not generate the demo photo.');
  return new File([blob], 'lumaframe-demo.jpg', { type: 'image/jpeg' });
}
